export const Config = {
    JWT_AUTH_HEADER_PREFIX: 'Bearer',
    // @ts-ignore
    GRAPHQL_API: window._env_ ? window._env_.GRAPHQL_API : '',
    // @ts-ignore
    MEDIA_URL: window._env_ ? window._env_.MEDIA_URL : '',
    APP_URL: 'http://localhost:3000'
};
